<template>
    <div class="badgebox-no-consent">
        <Badgebox :key="data.key">
            <p
                v-bastards
                class="fs-21 fs-lh-28 text-bold text-center"
            >
                Przykro nam, ale nie mamy Twojego adresu e-mail w naszej bazie.
            </p>

            <p
                v-bastards
                class="fs-16 text-center"
            >
                Zaloguj się i udziel zgody na otrzymywanie wiadomości e-mail.
            </p>
            <p
                v-bastards
                class="fs-16 text-center"
                style="padding-top: 18px;"
            >
                Numer karty: <strong>{{ data.partCard1 ? `${data.partCard1} ${data.partCard2} ${data.partCard3}` : '' }}</strong><br>
                <span v-if="data.firstName || data.lastName">Imię i nazwisko: <strong>{{ `${data.firstName || ''} ${data.lastName || ''}` }}</strong></span>
            </p>
            <form
                novalidate
                @submit.prevent="onSubmitSigninForm"
            >
                <InputNumber
                    v-model="nip"
                    :maxlength="10"
                    :is-required="true"
                    label="Twój NIP:"
                />
                <p class="text-center">
                    <button
                        class="button-primary btn btn-c--primary text-color-contrast fs-17 text-upper"
                        v-text="`Zaloguj się`"
                        style="padding: 13px 20px;"
                        type="submit"
                    />
                </p>
            </form>
        </Badgebox>

        <Modal
            :is-closeable="true"
            closeLabel="Zamknij okno"
            ref="modal"
        />
    </div>
</template>

<script>
import Badgebox from '@/components/badgebox/Badgebox'
// import ButtonPrimary from '@/components/button/ButtonPrimary'
import InputNumber from '@/components/form/InputNumber'
import Modal from '@/components/modal/Modal'

export default {
    components: {
        // ButtonPrimary,
        Badgebox,
        InputNumber,
        Modal
    },

    props: {
        data: {
            type: Object,
            required: false,
            default: () => {}
        }
    },

    data() {
        return {
            nip: ''
        }
    },

    methods: {
        onSubmitSigninForm() {
            this.handleFormSubmit()
        },

        handleFormSubmit() {
            console.log('[BadgeboxNoConsent] fire handleFormSubmit')

            this.$store.dispatch('apiSample/setSelectedSampleId', this.data.selectedSampleId)

            this.$store.dispatch('siteLoader/open')

            this.$store.dispatch('apiAuth/login', {
                partCard1: this.data.partCard1 || '',
                partCard2: this.data.partCard2 || '',
                partCard3: this.data.partCard3 || '',
                firstName: this.data.firstName || '',
                lastName: this.data.lastName || '',
                customerNip: this.nip
            })
                .then(() => {
                    this.$router.push({
                        name: 'zgody'
                    })
                })
                .catch(e => {
                    this.$store.dispatch('siteLoader/close')

                    this.$refs.modal
                        .open(`<header class="fs-32">Błąd logowania.</header><p class="fs-22">${e.response.data.message || ''}</p>`, 'center-small', function() {
                            console.log('closed')
                        })
                })
        }
    }
}
</script>

<style lang="scss">
.badgebox-no-consent {
    .badgebox {
        padding-bottom: 30px;
    }

    p {
        padding-top: 7px;

        strong {
            font-weight: $font-weight-bold;
        }
    }

    .input-number {
        max-width: 385px;
        padding-bottom: 9px;
        margin: 0 auto;

        label {
            text-align: center;
            padding: 20px 0 10px;
        }
    }
}
</style>
